export const qualificationList = [
  {Id: '1', Name: 'B.E / B.Tech'},
  {Id: '2', Name: 'M.E / M.Tech'},
  {Id: '3', Name: 'M.S / M.Tech'},
  {Id: '4', Name: 'M.S Engineering'},
  {Id: '5', Name: 'B. Eng (Hons)'},
  {Id: '6', Name: 'M.Eng (Hons)'},
  {Id: '7', Name: 'Engineering Diploma'},
  {Id: '8', Name: 'AE'},
  {Id: '9', Name: 'AET'},
  {Id: '10', Name: 'B.A'},
  {Id: '11', Name: 'B.Ed'},
  {Id: '12', Name: 'B.Jmc'},
  {Id: '13', Name: 'BFA'},
  {Id: '14', Name: 'B.Arch'},
  {Id: '15', Name: 'B.Des'},
  {Id: '16', Name: 'BMM'},
  {Id: '17', Name: 'MFA'},
  {Id: '18', Name: 'M.Ed'},
  {Id: '19', Name: 'M.A'},
  {Id: '20', Name: 'MSW'},
  {Id: '21', Name: 'MJMC'},
  {Id: '22', Name: 'M.Arch'},
  {Id: '23', Name: 'M.Des'},
  {Id: '24', Name: 'B.A (Hons)'},
  {Id: '25', Name: 'B.Arch (Hons)'},
  {Id: '26', Name: 'DFA'},
  {Id: '27', Name: 'D.Ed'},
  {Id: '28', Name: 'D.Arch'},
  {Id: '29', Name: 'AA'},
  {Id: '30', Name: 'AFA'},
  {Id: '31', Name: 'B.Com'},
  {Id: '32', Name: 'CA/CPA'},
  {Id: '33', Name: 'CFA'},
  {Id: '34', Name: 'CS'},
  {Id: '35', Name: 'Bsc/BFin'},
  {Id: '36', Name: 'M.Com'},
  {Id: '37', Name: 'Mse / Mfin / Ms'},
  {Id: '38', Name: 'B.Com (Hons)'},
  {Id: '39', Name: 'Pgd Finance'},
  {Id: '40', Name: 'BCA'},
  {Id: '41', Name: 'B.IT'},
  {Id: '42', Name: 'BCS'},
  {Id: '43', Name: 'BA Computer Science'},
  {Id: '44', Name: 'MCA'},
  {Id: '45', Name: 'PGDCA'},
  {Id: '46', Name: 'IT Diploma'},
  {Id: '47', Name: 'ADIT'},
  {Id: '48', Name: 'B.Sc'},
  {Id: '49', Name: 'M.Sc'},
  {Id: '50', Name: 'B.sc (Hons)'},
  {Id: '51', Name: 'DIPSC'},
  {Id: '52', Name: 'AS'},
  {Id: '53', Name: 'AAS'},
  {Id: '54', Name: 'MBBS'},
  {Id: '55', Name: 'BDS'},
  {Id: '56', Name: 'BPT'},
  {Id: '57', Name: 'BAMS'},
  {Id: '58', Name: 'BHMS'},
  {Id: '59', Name: 'B.Pharma'},
  {Id: '60', Name: 'BVSC'},
  {Id: '61', Name: 'BSN / BSCN'},
  {Id: '62', Name: 'MDS'},
  {Id: '63', Name: 'MCH'},
  {Id: '64', Name: 'M.D'},
  {Id: '65', Name: 'M.S Medicine'},
  {Id: '66', Name: 'MPT'},
  {Id: '67', Name: 'DM'},
  {Id: '68', Name: 'M.Pharma'},
  {Id: '69', Name: 'MYSC'},
  {Id: '70', Name: 'M Med'},
  {Id: '71', Name: 'PGD Medicine'},
  {Id: '72', Name: 'AND'},
  {Id: '73', Name: 'BBA'},
  {Id: '74', Name: 'BHM'},
  {Id: '75', Name: 'BBM'},
  {Id: '76', Name: 'MBA'},
  {Id: '77', Name: 'PGDM'},
  {Id: '78', Name: 'ABA'},
  {Id: '79', Name: 'ADBUS'},
  {Id: '80', Name: 'BL / LLB'},
  {Id: '81', Name: 'ML / LLM'},
  {Id: '82', Name: 'LLB (Hons)'},
  {Id: '83', Name: 'ALA'},
  {Id: '84', Name: 'Bachelor'},
  {Id: '85', Name: 'Master'},
  {Id: '86', Name: 'Diploma'},
  {Id: '87', Name: 'Hounarse'},
  {Id: '88', Name: 'Doctorate'},
  {Id: '89', Name: 'Associate'},
  {Id: '90', Name: 'High School'},
  {Id: '91', Name: 'Less Then High School'},
  {Id: '92', Name: 'Non Matric'},
];
